import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getMonthlyDonations, getMonthlyDonationById } from '../../api/services/monthlyDonationService';

// Async thunks
export const fetchMonthlyDonationsAction = createAsyncThunk(
  'monthlyDonation/fetchMonthlyDonations',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getMonthlyDonations();
      return response;
    } catch (error) {
      return rejectWithValue(error?.message || 'Failed to load monthly donations');
    }
  }
);

export const fetchMonthlyDonationByIdAction = createAsyncThunk(
  'monthlyDonation/fetchMonthlyDonationById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await getMonthlyDonationById(id);
      return response;
    } catch (error) {
      return rejectWithValue(error?.message || 'Failed to load monthly donation');
    }
  }
);

const initialState = {
  list: [],
  byId: {},
  loading: false,
  error: null,
};

const monthlyDonationSlice = createSlice({
  name: 'monthlyDonation',
  initialState,
  reducers: {
    clearMonthlyDonationError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMonthlyDonationsAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMonthlyDonationsAction.fulfilled, (state, action) => {
        state.loading = false;
        state.list = Array.isArray(action.payload?.data) ? action.payload.data : [];
      })
      .addCase(fetchMonthlyDonationsAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchMonthlyDonationByIdAction.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMonthlyDonationByIdAction.fulfilled, (state, action) => {
        state.loading = false;
        const donation = action.payload?.data || {};
        if (donation?.id) state.byId[donation.id] = donation;
      })
      .addCase(fetchMonthlyDonationByIdAction.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearMonthlyDonationError } = monthlyDonationSlice.actions;
export default monthlyDonationSlice.reducer;

